import React, { useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner"; // Import the spinner

const MyQualification = () => {
  const [loading, setLoading] = useState(true);

  // Qualification steps and content
  const steps = [
    "O/L Results - Tzu-Chi National School (Hambantota)",
    "A/L Results - Tzu-Chi National School (Hambantota)",
    "University Of Moratuwa Faculty of IT",
    "Freelancing",
  ];

  const stepContent = [
    "Completed O/L with excellent results, passing all subjects with 9A's. Including ICT",
    "Achieved top grades in A/L, specializing in Mathematics ABB. Also eligible to select for engineering faculty. But in order to find a cure for my endless enthusiasm for computer and programming I thought it would better following an IT course that having excellent reputation in industry.",
    "Enrolled in university to study IT, gaining hands-on experience with coding and software development. The practical projects I worked on built my skills in programming and problem-solving.",
    "Started freelancing, building web applications and giving my services in various technologies as well as frameworks. This was an exciting phase where I applied everything I had learned to real-world projects, interacting with clients and enhancing my web development skills.",
  ];

  const images = [
    "/journey/1.jpg",
    "/journey/1.jpg",
    "/journey/2.jpg",
    null, // No image for freelancing
  ];

  useEffect(() => {
    // Set a timer to hide the spinner after 0.5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // 500 milliseconds delay

    // Clear the timer if the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div style={{ margin: "7%" }}>
          <h2>My Journey</h2>
          <p style={{ color: "#808080" }}>Details about my journey...</p>

          {/* Render steps as cards */}
          <div style={{ marginTop: "2%" }}>
            {steps.map((step, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                  padding: "20px",
                  backgroundColor: "#f8f8f8",
                  borderRadius: "8px",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Text Section */}
                <div style={{ flex: 1 }}>
                  <h3 style={{ color: "#333" }}>{step}</h3>
                  <p style={{ color: "#555", marginTop: "1%" }}>
                    {stepContent[index]}
                  </p>
                </div>

                {/* Image Section (Only for first 3 cards) */}
                {images[index] && (
                  <img
                    src={images[index]}
                    alt={`Step ${index + 1}`}
                    style={{
                      width: "250px",
                      height: "250px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      marginLeft: "20px",
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyQualification;
